<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-2 p-3">
                <VerticalNavbar />
            </div>
            <div class="col-12 col-md-7" style="height: 100%;">
                <LiveStreamComponent v-if="$store.state.isMobileScreen && $store.state.settings.showLiveStream" />
                <router-view />
            </div>
            <SisBetslip />
        </div>
    </div>
</template>
<script>
import LiveStreamComponent from "@/components/livestream/index.vue"
import VerticalNavbar from "@/components/navbar/vertical-nav.vue"
import SisBetslip from "@/components/right-bar/sis-betslip.vue";

export default {
    components: { VerticalNavbar, LiveStreamComponent, SisBetslip }
}
</script>